import { yupResolver } from '@hookform/resolvers/yup';
import { Dialog } from '@mui/material';
import { MAX_NAME_CHARACTERS } from 'common/constants';
import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { FlexButton } from 'v3/shared/components/Button/FlexButton';
import { TextButton } from 'v3/shared/components/Button/TextButton';
import { InputFormController } from 'v3/shared/components/Inputs/InputFormController';
import {
  AlignButtons,
  CloseIconStyled,
  Gap,
  MainContainer,
  SecondaryContainer,
  TitleContainer,
  paperStyles,
} from 'v3/shared/components/Modal/GenericNameModal/styles';
import { SubtitleLarge } from 'v3/shared/typography/SubtitleLarge';
import { object, string } from 'yup';

interface IGenericNameModalProps {
  title: string;
  active: boolean;
  onClose: () => void;
  currentName?: string;
  onSave: (newName: string) => void;
}

interface IFormData {
  name: string;
}

const schema = object({
  name: string()
    .required('Inserir um nome é obrigatório')
    .max(MAX_NAME_CHARACTERS, `O nome deve ter no máximo ${MAX_NAME_CHARACTERS} caracteres`)
    .trim(),
});

export const GenericNameModal: React.FC<IGenericNameModalProps> = ({ title, active, onClose, currentName, onSave }) => {
  const {
    control,
    getValues,
    reset,
    formState: { isValid },
  } = useForm<IFormData>({
    mode: 'onChange',
    reValidateMode: 'onChange',
    defaultValues: {
      name: currentName ?? '',
    },
    resolver: yupResolver(schema),
  });

  useEffect(() => {
    reset({
      name: currentName ?? '',
    });
  }, [active, currentName, reset]);

  const handleSave = () => {
    const newName = getValues('name').trim();
    onSave(newName);
    onClose();
  };

  return (
    <Dialog
      onClose={onClose}
      open={active}
      aria-labelledby="customized-dialog-title"
      aria-describedby="customized-dialog-description"
      PaperProps={paperStyles}
    >
      <MainContainer>
        <TitleContainer>
          <SecondaryContainer>
            <SubtitleLarge>{title}</SubtitleLarge>
          </SecondaryContainer>
          <CloseIconStyled onClick={onClose} />
        </TitleContainer>
        <Gap>
          <InputFormController
            data-testid="input-store-name"
            formControl={control}
            formControlName="name"
            label="Nome"
          />
          <AlignButtons>
            <TextButton text="Cancelar" $outline size="small" handleClick={onClose} />
            <FlexButton text="Salvar alterações" size="small" disabled={!isValid} handleClick={handleSave} />
          </AlignButtons>
        </Gap>
      </MainContainer>
    </Dialog>
  );
};
